import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger)

let sliders = gsap.utils.toArray('.slider')
sliders.forEach(slider => {
  let $slider = gsap.utils.selector(slider)

  ScrollTrigger.create({
    trigger: slider,
    start: 'top 45%',
    end: '20% 45%',
    onEnter: function () {
      if ($slider('.slide').length > 1) {
        $slider('.slide').forEach(slide => {
          slide.style.transform = 'translateX(-100%)'
        })
      }
    },
    onLeave: function () {
      if ($slider('.slide').length > 1) {
        $slider('.slide').forEach(slide => {
          slide.style.transform = 'translateX(-100%)'
        })
      }
    },
    onLeaveBack: function () {
      if ($slider('.slide').length > 1) {
        $slider('.slide').forEach(slide => {
          slide.style.transform = 'translateX(0)'
        })
      }
    },
    onEnterBack: function () {
      if ($slider('.slide').length > 1) {
        $slider('.slide').forEach(slide => {
          slide.style.transform = 'translateX(0)'
        })
      }
    }
  })
})

export default sliders
